module.exports = __webpack_public_path__ + "static/media/readyMadeMealsMixes.6db1e17e.webp";